export interface ImportantNoteStep {
  title: string;
  content: string;
  color: string; // tailwind text color class for the step (if needed per future use)
}

// Shared steps used by both registration and add payment method flows
export const importantNotesSteps: ImportantNoteStep[] = [
  {
    title: 'Important Note!',
    content:
      'RM1.00 will be deducted and automatically refunded within 7 days for authentication purpose',
    color: 'text-orange-500'
  },
  {
    title: 'Important Note!',
    content:
      "If you're selecting card. On the next page, be sure to tick the 'save payment details' checkbox",
    color: 'text-green-500'
  }
];
